// extracted by mini-css-extract-plugin
export var formContainer = "_jc-0";
export var message = "_jc-1";